import { Tooltip } from "@mantine/core"
import {
  ActionIconPencil,
  ActionIconArrowMergeLeft,
  ActionIconArrowRampLeft2,
  ActionIconPlus,
} from "@components/action-icons"
import { useTranslation } from "react-i18next"

interface EditResourceDetailsActionIconProps {
  onClick: () => void
}

export function EditResourceObjectDetailsActionIcon({
  onClick,
}: EditResourceDetailsActionIconProps) {
  const { t } = useTranslation("app_server")

  return (
    <Tooltip label={t("Edit")}>
      <ActionIconPencil onClick={onClick} />
    </Tooltip>
  )
}

interface BorrowActionIconProps {
  onClick: () => void
  isBorrowed: boolean
}

export function BorrowResourceObjectActionIcon({
  onClick,
  isBorrowed,
}: BorrowActionIconProps) {
  const { t } = useTranslation("app_server")

  return isBorrowed ? (
    <Tooltip label={t("Return")}>
      <ActionIconArrowMergeLeft onClick={onClick} />
    </Tooltip>
  ) : (
    <Tooltip label={t("Lend")}>
      <ActionIconArrowRampLeft2 onClick={onClick} />
    </Tooltip>
  )
}

interface EditObjectFieldsActionIconProps {
  onClick: () => void
}

export function EditResourceObjectFieldsActionIcon({
  onClick,
}: EditObjectFieldsActionIconProps) {
  const { t } = useTranslation("app_server")

  return (
    <Tooltip label={t("Edit")}>
      <ActionIconPencil onClick={onClick} />
    </Tooltip>
  )
}

interface AddResourceObjectActionIconProps {
  onClick: () => void
}

export function AddResourceObjectActionIcon({
  onClick,
}: AddResourceObjectActionIconProps) {
  const { t } = useTranslation("app_server")

  return (
    <Tooltip label={t("Add")}>
      <ActionIconPlus onClick={onClick} />
    </Tooltip>
  )
}

interface EditResourceObjectInsuranceActionIconProps {
  onClick: () => void
}

export function EditResourceObjectInsuranceActionIcon({
  onClick,
}: EditResourceObjectInsuranceActionIconProps) {
  const { t } = useTranslation("app_server")

  return (
    <Tooltip label={t("Edit")}>
      <ActionIconPencil onClick={onClick} />
    </Tooltip>
  )
}
